<template>
	<div class="container">
		<div class="row">

			<div class="col-lg-4">
				<h2 class="h h--2 h--dark">Nagrody</h2>
				<p class="paragraph">
					Poznaj i zamawiaj nagrody, jakie przygotowaliśmy w Programie Geberit Pro.
				</p>

				<user-points-info-widget/>

				<p class="paragraph">
					<router-link :to="{name: 'MyPrizes'}" class>Zamówione nagrody &raquo;</router-link>
				</p>

				<div v-if="contests.length > 1">
					<p class="paragraph">Wyświetl nagrody w:</p>
					<div class="paragraph" v-for="contest in contests" :key="contest.id">
						<input
						type="checkbox"
						:name="'contest' + contest.id"
						:id="'contest' + contest.id"
						class="form__checkbox"
						v-model="contest.checked"
						/>
						<label :for="'contest' + contest.id">
							<span>{{ contest.name }}</span>
						</label>
					</div>
				</div>

				<hr>

				<p class="paragraph">
					UWAGA! Zamówione nagrody
					stanowią dochód i podlegają
					opodatkowaniu.
					Masz pytania? Skontaktuj się
					z Koordynatorem Geberit Pro.
				</p>
			</div>


			<div class="col-lg-8 prizes__wraper" v-bind:class="{'pending': pagination.pending}">
				<div
				v-for="contest in contests"
				:key="contest.id"
				v-if="contest.checked"
				>

				<h3 class="prizes__heading" >{{ contest.front_title }}</h3>

				<div v-if="contest.display_type == 'groups'">
					<div class="row row-eq-height prizes__list">
						<div class="col-md-6 col-lg-3 prizes__grouped" v-for="prize_group in contest.prize_groups">
							<div class="prizes__item">
								<div class="prizes__item-img" v-if="prize_group.photo_id">
									<img v-auth-image="'/photos/'+ prize_group.photo_id + '?thumbnail=300'"  />
								</div>
								<div class="prizes__item-desc prizes__item-desc--sm">
									<p>{{prize_group.name}}</p>
									<div class="prizes__item-footer">
										<router-link
										:to="{name: 'PrizeGroup', params: { contest_id: contest.id, prize_group_id: prize_group.id }}"
										class="button button--small button--blue prizes__item-button"
										>Przejdź &raquo;</router-link>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<prizes-list v-else :prizes="contest.prizes" :pagination="pagination"/>


				<!-- Grupy nagród są wyłącznie w nagrodach geberit pro -->
				<!-- Zakomentowane w ogóle w związku z https://rm2.mda.pl/issues/3260 -->

				</div>

			</div>

		</div>

		<page-box-set-widget prizes="true"></page-box-set-widget>

	</div>
</template>

<script>
import Vue from "vue";
import Vue2Filters from "vue2-filters";
import { store } from "@/app/store";
import moment from 'moment';

export default {
	name: "PrizesComponent",
	mixins: [Vue2Filters.mixin],
	data() {
		return {
			prizes: [],
			pagination: {},
			contests: {},
		};
	},
	beforeRouteEnter(to, from, next) {
		Vue.axios({
			method: "get",
			url: "/contests/prizes"
		})
		.then((contestsReponse) => {
			next(vm => {
				vm.contests = contestsReponse.data.data.contests.filter(function(
					c
					) {
					c.checked = true;
					c.prizes.filter(function(p) {
						p.value = parseFloat(p.value);
						return p;
					});
					return c;
				});
			});
		})
		.catch(error => next(false));
	},
	computed: {
		user() {
			return this.$store.state.user;
		}
	},
	mounted: function() {
		if (!this.user || this.user.id != 1) {
			this.$gtag.pageview({
				page_path: "/nagrody"
			});
		}
	},
	methods: {
		handleOk(evt) {
			// Prevent modal from closing
			evt.preventDefault();
			if (!this.name) {
				alert("Please enter your name");
			} else {
				this.handleSubmit();
			}
		},
		handleSubmit() {
			this.names.push(this.name);
			this.clearName();
			this.$refs.modal.hide();
		},

		/**
		* On change paginate event.
		*
		* @param  {int} page
		* @return void
		*/
		onChangePaginate(page) {
			let vm = this;

			vm.pagination.pending = true;

			Vue.axios({
				method: "get",
				url: "/prizes",
				params: {
					page: page
				}
			})
			.then(response => {
				vm.prizes = response.data.data.prizes;
				vm.pagination = response.data.pagination;
			})
			.catch(error => (vm.pagination.pending = false));
		},

	}
};
</script>



// WEBPACK FOOTER //
// src/app/home/prizes/PrizesComponent.vue